"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAvroRecord = void 0;
var BaseAvroRecord_1 = require("@chasdevs/avro-to-typescript/dist/src/components/Avro/BaseAvroRecord");
Object.defineProperty(exports, "BaseAvroRecord", { enumerable: true, get: function () { return BaseAvroRecord_1.BaseAvroRecord; } });
//# sourceMappingURL=BaseAvroRecord.js.map